import { poisWithDistances } from "@common/features/GoogleMaps/components/data/poisWithDistances"
import { create } from "zustand"

export type TravelMode = "WALKING" | "DRIVING" | "TRANSIT" | "BICYCLING"
export type TransitMode = "SUBWAY" | "BUS" | "RAIL" | "TRAIN" | "TRAM"

type DistanceInfo = {
  distance?: string
  duration?: string
}

type Coordinates = {
  lat: number
  lng: number
}

export type Distances = Record<TravelMode, DistanceInfo>

export type POI = {
  id?: string
  name: string
  description?: string
  category?: string
  iconPath?: {
    publicURL?: string
  }
  coordinates: Coordinates
  distances?: Distances
  custom?: boolean
  image?: string
  path?: any
  steps?: any
  routes?: any
} & { place?: string }

export interface MapState {
  activePOI: POI | null
  setActivePOI: (activePOI: POI | null) => void
  activeSection: "pois" | "directions"
  setActiveSection: (activeSection: "pois" | "directions") => void
  currentCategory: string
  setCurrentCategory: (category: string | undefined) => void
  travelMode: TravelMode
  setTravelMode: (travelMode: TravelMode) => void
  transitMode: TransitMode
  setTransitMode: (transitMode: TransitMode) => void
  routeSteps: google.maps.DirectionsStep[]
  setRouteSteps: (routeSteps: google.maps.DirectionsStep[]) => void
  mapInstance: google.maps.Map | null
  setMapinstance: (map: google.maps.Map | null) => void
  placesState: any
  searchBoxPrediction: any
  setSearchBoxPrediction: (searchBoxPrediction: any) => void
  searchBoxSuggestions: any
  setSearchBoxSuggestions: (searchBoxSuggestions: any) => void
}

export const useMapStore = create<MapState>()((set) => ({
  activePOI: null,
  setActivePOI: (activePOI: POI | null) => {
    set({ activePOI })
  },
  currentCategory: "all",
  setCurrentCategory: (currentCategory: string | undefined) => {
    set({ currentCategory })
  },
  travelMode: "TRANSIT",
  setTravelMode: (travelMode: TravelMode) => {
    set({ travelMode })
  },
  transitMode: "SUBWAY",
  setTransitMode: (transitMode: TransitMode) => {
    set({ transitMode })
  },
  routeSteps: [],
  setRouteSteps: (routeSteps: google.maps.DirectionsStep[]) => {
    set({ routeSteps })
  },
  activeSection: "pois",
  setActiveSection: (activeSection: "pois" | "directions") => {
    set({ activeSection })
  },
  mapInstance: null,
  setMapinstance: (map) => {
    set({ mapInstance: map })
  },
  placesState: poisWithDistances,
  searchBoxPrediction: null,
  setSearchBoxPrediction: (searchBoxPrediction) => {
    set({ searchBoxPrediction })
  },
  searchBoxSuggestions: null,
  setSearchBoxSuggestions: (searchBoxSuggestions) => {
    set({ searchBoxSuggestions })
  },
}))
